import { render } from "./ExpertRecommendations.vue?vue&type=template&id=aad9accc"
import script from "./ExpertRecommendations.vue?vue&type=script&lang=js"
export * from "./ExpertRecommendations.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__